import { formatNumber } from 'utils/numberFormat';
import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { cx } from '@emotion/css';
import { getPopupContainer } from 'components/LightConversation/utils/popover';
import React from 'react';
interface PaymentItemProps {
  label: string;
  price?: number;
  unit?: string;
  description?: string | React.ReactNode;
  size?: 'small' | 'medium';
}

export const PaymentItem = (props: PaymentItemProps) => {
  const { label, price, unit, size = 'medium', description } = props;

  const sizeLabelCls =
    size === 'small' ? 'text-[12px] text-[#84868C]' : 'text-[14px] text-[#515359]';
  const siezPriceCls =
    size === 'small' ? 'text-[12px] text-[#515359]' : 'text-[14px] text-[#232426]';

  return (
    <div className="flex items-center justify-between">
      <div className={cx(sizeLabelCls, 'flex items-center gap-0.5')}>
        {label}
        {description && (
          <Tooltip title={description} getPopupContainer={getPopupContainer}>
            <QuestionCircleOutlined className="cursor-pointer" />
          </Tooltip>
        )}
      </div>
      <div className={siezPriceCls}>
        {unit} {formatNumber(price, '0,0.00')}
      </div>
    </div>
  );
};
